import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var list_item_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12 11v1.5h8V11h-8zm-6-1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }) });
export {
  list_item_default as default
};
//# sourceMappingURL=list-item.js.map
